import PropTypes from 'prop-types';
import React from 'react';
import { AccessibilityText } from '@glu/utilities-react';
import StyledSelect from './StyledSelect';

const SelectYears = ({ head, index, onChange, yearDropdownMaxYear, yearDropdownMinYear }) => {
  const years = [];
  for (let i = yearDropdownMinYear; i <= yearDropdownMaxYear; i += 1) {
    years.push(i);
  }
  return (
    <StyledSelect>
      <label htmlFor={`select-year-${index}`}>
        <AccessibilityText>Years</AccessibilityText>
        <select
          data-qa={`select-year-${index}`}
          id={`select-year-${index}`}
          onChange={(event) => {
            onChange(event.target.value);
          }}
          value={head.year()}
        >
          {years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </label>
    </StyledSelect>
  );
};

SelectYears.propTypes = {
  head: PropTypes.shape({
    year: PropTypes.func,
  }).isRequired,
  index: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.shape({}),
  yearDropdownMaxYear: PropTypes.number.isRequired,
  yearDropdownMinYear: PropTypes.number.isRequired,
};

SelectYears.defaultProps = {
  options: {},
};

export default SelectYears;
